export enum InputCellType {
    EMAIL = 'email',
    NUMBER = 'number',
    PASSWORD = 'password',
    TEXT = 'text'
}



// WEBPACK FOOTER //
// ./src/enums/InputCellType.ts